var intervalCountdown;

function countdown(length, spanClass, callback) {
    clearInterval(intervalCountdown)

    // if span does not exist. do not start countdown
    if (document.querySelector(spanClass) == null)
        return

    // set required length in innerHTML
    document.querySelector(spanClass).innerHTML = length > 0 ? length : ''

    intervalCountdown = setInterval(function () {
        document.querySelector(spanClass).innerHTML = length-- > 0 ? length : ''

        if (length <= 0) {
            clearInterval(intervalCountdown)

            document.querySelector(spanClass).innerHTML = ''

            if (typeof callback == 'function')
                callback()
        }
    }, 1000)
}
